import React from "react";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

export default ({ buttons, color, outline }) => {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: color || "#d7e0da",
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <ButtonGroup
        style={{
          display: `flex`,
          flexDirection: `row`,
          width: `100%`,
        }}
        color="primary"
        variant={outline ? "outlined" : "text"}
        aria-label={`primary button group`}
      >
        {buttons}
      </ButtonGroup>
    </MuiThemeProvider>
  );
};
